import './gfade.scss';

import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {delay} from '../../utils/async';
import {ResizeAF} from '../../utils/ResizeAF';
import {isInViewport} from '../../utils/miscellanea';
import {LANGTAG} from "../../global_vars";
// import { ResizeAF } from '../../utils/ResizeAF';

const template = `
<div>
<p class="gfade" :class="cls" v-html="content"></p>
<div style="visibility: hidden;position: absolute;" ref="wrapper">
<slot></slot>
</div>
</div>
`;

@Component({
  template: template
})
export default class GFade extends Vue {
  @Prop({ default: 250 }) duration!: number;
  @Prop({ default: false }) disabled!: string;
  @Prop({ default: false }) triggerOnScreen!: string;

  started = false;
  cls = '';
  content = '';

  created(): void {
  }

  async mounted() {
    // @ts-ignore
    const textContent = (<HTMLElement>this.$refs['wrapper']).innerHTML;

    if (this.disabled) {
      this.content = textContent;
      this.cls = 'gfade--in';
      return;
    }

    this.content = textContent.split('<br>').map((line) => {
      const words = line.split(' ').map((v, i) => {
        return `<span class='gfade__it'><span class='gfade__it-inner' style='transition-delay: ${i * 30}ms'>${v}</span></span>`;
      });

      // if (LANGTAG == 'fa') return words.reverse().join(' ');

      return words.join(' ');
    }).join('<br>');

    if (this.triggerOnScreen) {
      this.setupOnScreenTrigger();
    } else {
      await delay(this.duration);
      this.cls = 'gfade--in';
    }
  }

  setupOnScreenTrigger() {
    const el = this.$el;

    ResizeAF.instance().once(() => {
      if (isInViewport(el as HTMLElement)) {
        this.cls = 'gfade--in';
        return true;
      }

      return false;
    });
  }
}
